import { applyMiddleware, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import { API } from "../api/comunApi";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import axiosMiddleware from "redux-axios-middleware";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "../reducers/index";
import storage from "redux-persist/lib/storage";
import thunkMiddleware from "redux-thunk";

const persistConfig = {
  key: "root",
  // whitelist: [],
  storage: storage,
  stateReconciler: autoMergeLevel2,
};

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  pReducer,
  composeWithDevTools(applyMiddleware(thunkMiddleware, axiosMiddleware(API)))
);

export const persistor = persistStore(store);
